import script from "./edit-html-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit-html-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__